export default "__VITE_ASSET__ba119457__"